import { Button, Layout } from 'components'
import { useEffect, useState } from 'react'
import styles from './AccountingPage.module.scss'

import { useDispatch, useSelector } from 'react-redux'

import right from 'assets/icons/chevron_right.png'

import { useNavigate } from 'react-router-dom'

import { PostAccounting, getAccountingData } from "service/AccountingService";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import userInfo from 'utils/userInfo'

const AccountingPage = () => {
  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState(false);
  const [body, setBody] = useState("");
  const [render, setRender] = useState(false)
  const [data, setData] = useState([]);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const getData = async () => {
    try {
      let response = await getAccountingData(data);
      setData(response.data);

    } catch (error) {
      console.log("onoxo")
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!body) {
      setNotify({
        isOpen: true,
        message: "Введите наименование фонда!",
        type: "error",
      });

    }
    else {
      const formData = new FormData();
      formData.append('name', body);


      let data = await PostAccounting(formData);

      getData();

      setBody("");
      setOpenModal(false)
      setNotify({
        isOpen: true,
        message: "Фонд успешно создан!",
        type: "success",
        sound: "success"
      });
      setRender(true)
    }

  };
  const handleClick = (id) => {
    // Ensure that the navigation happens only on a button click
    if (typeof id !== "undefined") {

      navigate(`/accounting-info/`, { state: { usedId: id } });
    }
  };

  useEffect(() => {

    getData();

    setRender(false);


  }, [render]);
  return (
    <Layout>
      <div className={styles.project__wrapper}>
        <div className={styles.project__header}>
          <div className={styles.title}>
            Бухгалтерия
            <img
              src={right}
              alt=""
              style={{
                paddingLeft: '10px',
                paddingRight: '10px',
                verticalAlign: 'middle',
              }}
            />
          </div>

        </div>
        <div className={styles.project__body}>
          <div className={styles.project__header__in}>
            <h2 className={styles.project__h}>Ваши фонды</h2>
            <>
              <Button className={styles.btn_pin} onClick={() => setOpenModal(true)} >
                Создать фонд
              </Button>
            </>
          </div>

        </div>
        <div className={styles.project__body_info}>
          {Array.isArray(data) && data.map((item) => (
            <div className={styles.project__body} key={item.id}>
              <div className={styles.project__card}>
                <h2>{item.name}</h2>
                <Button className={styles.btn_pin} onClick={() => handleClick(item.id)}>
                  Перейти
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <ModalWindow
        openModal={openModal}
        setOpenModal={setOpenModal}
        modalText={'Введите название фонда'}
      >
        <>
          <div className={styles["note-input"]}>

            <form onSubmit={handleSubmit} >

              <input
                type="text"
                placeholder="Введите название фонда:"
                className={styles.type_input}
                value={body}
                name="body"
                onChange={(e) => setBody(e.target.value)}
              />

              <div className={styles.create_footer}>


                <button
                  type="submit"
                  className={styles.open_btn_sub}

                >
                  Создать
                </button>
              </div>
            </form>
          </div>
          <Button
            onClick={() => setOpenModal(false)}
            className={styles.close_btn_sub}
          >
            {" "}
            Закрыть
          </Button>
        </>
      </ModalWindow>

    </Layout>
  )
}

export default AccountingPage
